import { createContext } from '../utils';
var ListContext = createContext({
  bordered: false,
  size: 'md',
  manager: null
});
export default ListContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rsuite/es/List/ListContext.js
// module id = 1061
// module chunks = 35